import { useLoadVariables as useLoadProjectVariables } from "Reducers/project/settings/variable/hooks/useLoadVariables";

import { useLoadVariables } from "./useLoadVariables";

export function useGetVariable({
  organizationId,
  projectId,
  variableId,
  environmentId
}: {
  organizationId: string;
  projectId: string;
  variableId: string;
  environmentId: string;
}) {
  const { variables: projectListVariables } = useLoadProjectVariables({
    organizationId,
    projectId
  });
  const { variable, getOrigin, isOverridingFrom, loading, errors, status } =
    useLoadVariables({
      organizationId,
      projectId,
      environmentId,
      projectListVariables,
      variableId
    });

  return {
    variable,
    getOrigin,
    isOverridingFrom,
    loading,
    errors,
    status
  };
}
